<template>
  <section
    v-if="courses.length"
  >
    <img class="img-fluid img-divisor" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjE4Mi41IiB2aWV3Qm94PSIwIDAgMTQ0MCAxODIuNSI+CiAgICA8ZGVmcz4KICAgICAgICA8c3R5bGU+CiAgICAgICAgICAgIC5jbHMtMXtmaWxsOiNmM2YzZjN9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxwYXRoIGlkPSJlbGVtZW50X2JhY2tncm91bmQtbGlnaHQtZ3JleSIgZD0iTTE2ODU3LTEwMTQwLjVoLTE0NDB2LTE4LjljMzQuMDk1IDQuMiA2OC44MTQgNy40IDEwMy4yIDkuNXM2OS4zOTMgMy4xNzQgMTA0LjA3NCAzLjE3NGExNjY0LjYyMiAxNjY0LjYyMiAwIDAgMCA0ODMuNjctNzEuNiAyNDI5LjU1MyAyNDI5LjU1MyAwIDAgMSAxNzYuMjExLTQ2LjNjNTguMjg5LTEzIDExNy44ODktMjMuOTkgMTc3LjE0MS0zMi42NThhMjQ0OS41MDIgMjQ0OS41MDIgMCAwIDEgMTc3LjI2NC0xOS4zNDdjNTguNS00LjIzIDExNy45MjItNi4zNzUgMTc2LjYxMy02LjM3NWguMTMzYzEzLjYgMCAyNy42MjMuMTIxIDQxLjcuMzU5djE4Mi4xMzl6IiBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iZWxlbWVudC9iYWNrZ3JvdW5kLWxpZ2h0LWdyZXkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTQxNyAxMDMyMy4wMDEpIi8+Cjwvc3ZnPg==" />
    <SectionContainer variant="gray">
      <SectionHeader>
        <template #title>
          <b>Aqui os <span class="hl">lançamentos</span> não param!</b>
        </template>
        
        <template #subtitle>Conteúdo novo e atualizado sempre sendo produzido</template>
      </SectionHeader>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4"
          v-for="course in courses"
          :key="course.id"
        >
          <CourseThumbBox
            :course="course"
            :is-coming-soon="true"
            class="course-box"
          />
        </div>
        </div>
      </div>
    </SectionContainer>
  </section>
</template>

<script>
  import { getComingSoonCourses } from '@/api/course.api'
  import SectionContainer from '@/components/layout/SectionContainer'
  import SectionHeader from '@/components/layout/SectionHeader'
  import CourseThumbBox from '@/components/course/CourseThumbBox'

  export default {
    components: {
      SectionContainer,
      SectionHeader,
      CourseThumbBox
    },

    data: () => ({
      courses: []
    }),

    mounted () {
      this.fetchCourses() 
    },

    methods: {
      async fetchCourses () {
        const response = await getComingSoonCourses()
        this.courses = response.data
      }
    }
  }
</script>

<style scoped lang="scss">
  .img-divisor { width: 100vw }
</style>
